<template>
  <div
    class="subproperty-people-page"
    v-if="tabs[activeTabIndex]"
  >
    <!-- Inscription list -->
    <app-inscription-list-page
      v-if="tabs[activeTabIndex].type === 'inscriptions'"
    />

    <!-- Player list -->
    <app-player-list-page
      v-if="tabs[activeTabIndex].type === 'players'"
    />
    
    <!-- Family list -->
    <app-family-list-page
      v-if="tabs[activeTabIndex].type === 'families' && subpropertyId"
      :subpropertyId="subpropertyId"
    />

    <!-- Parent list -->
    <app-parent-list-page
      v-if="tabs[activeTabIndex].type === 'parents' && subpropertyId "
      :subpropertyId="subpropertyId"
    />

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import InscriptionListPage from '@modules/inscription/components/inscription-list-page.vue';
import PlayerListPage from '@modules/player/components/player-list-page.vue';
import ParentListPage from '@modules/parent/components/parent-list-page.vue';
import FamilyListPage from '@modules/family/components/family-list-page.vue';

export default {
  name: 'subproperty-people-page',

  props: {
    tabName: String,
    subtabName: String,
  },

  computed: {
    ...mapGetters({
      tabs: 'subpropertyPeople/tabs',
      subtabs: 'subpropertyPeople/subtabs',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      activeSubtabIndex: 'layout/headerTabs/activeSubtabIndex',
      currentManage: 'auth/manage/currentManage'
    }),

    subpropertyId() {
      if (
        this.currentManage &&
        this.currentManage.subproperty &&
        this.currentManage.subproperty.id
      ) {
        return this.currentManage.subproperty.id;
      } else {
        return null;
      }
    },
  },

  mounted() {
    this.resetTabs();
    this.setTabs(this.tabs);
    this.parseActiveTab();
    const isInscriptionTab = this.tabs[this.activeTabIndex].type === 'inscriptions';

    if (isInscriptionTab) {
      this.resetSubtabs();
      this.setSubtabs(this.subtabs); 
      this.parseActiveSubTab();
    }

    // Reset player filter
    this.doResetPlayer();
    // Reset parent filter
    this.doResetParent();
  },

  beforeDestroy() {
    this.resetTabs();
    this.resetSubtabs();
  },

  methods: {
    ...mapActions({
      setTabs: 'layout/headerTabs/setTabs',
      setSubtabs: 'layout/headerTabs/setSubtabs',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
      setActiveSubTabIndex: 'layout/headerTabs/setActiveSubtabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
      resetSubtabs: 'layout/headerTabs/resetSubtabs',
      doResetPlayer: 'player/list/doReset',
      doResetParent: 'parent/list/doReset',
    }),

    parseActiveTab() {
      var activeTabIndex = this.activeTabIndex;

      if (this.tabName) {
        activeTabIndex = this.tabs.findIndex(({ type }) => type == this.tabName);
      }
      
      this.setActiveTabIndex(activeTabIndex)
    },

    parseActiveSubTab() {
      var activeSubtabIndex = this.activeSubtabIndex;

      if (this.subtabName) {
        activeSubtabIndex = this.subtabs.findIndex(({ type }) => type == this.subtabName);
      }
      
      this.setActiveSubTabIndex(activeSubtabIndex);
    },
  },

  components: {
    [InscriptionListPage.name]: InscriptionListPage,
    [PlayerListPage.name]: PlayerListPage,
    [ParentListPage.name]: ParentListPage,
    [FamilyListPage.name]: FamilyListPage,
  },

  watch: {
    activeTabIndex() {
      this.parseActiveTab();
      const tabName = this.tabs[this.activeTabIndex].type;
      
      if (tabName === 'inscriptions') {
        this.setSubtabs(this.subtabs);
        this.parseActiveSubTab();
      } else {
        this.resetSubtabs();
      }
    },
    activeSubtabIndex() {
      this.parseActiveSubTab();
    }
  },
};
</script>

